import { Directive } from "@angular/core";

/**
 * Marker directive that opts a native input/textarea/select into the
 * design-system styling. The actual styles live in
 * src/styles/forms.scss because directives can't ship their own
 * stylesheet — being global lets us also drive error styling from
 * an ancestor bv-form-field via [data-error].
 *
 *   <input bv-input type="email" [(ngModel)]="email" />
 *   <textarea bv-input rows="4"></textarea>
 *   <select bv-input>...</select>
 */
@Directive({ selector: "input[bv-input], textarea[bv-input], select[bv-input]" })
export class BvInputDirective {}
